import React from 'react';
import PropTypes from 'prop-types';
import clsx from '@strava/ui/clsx';

import styles from './Card.scss';

const Card = ({ children, className, dataTestId }) => (
  <div className={clsx(styles.container, className)} data-testid={dataTestId}>
    {children}
  </div>
);

Card.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  dataTestId: PropTypes.string
};

Card.defaultProps = {
  className: null,
  dataTestId: undefined
};

export default Card;
